import { IncomeSource } from '~/data/common'

export enum JBCredIncomeSource {
  UNKNOWN_INCOME_SOURCE = 'UNKNOWN_INCOME_SOURCE',
  ASSALARIADO_CLT = 'ASSALARIADO_CLT',
  FUNCIONARIO_PUBLICO_ATIVO = 'FUNCIONARIO_PUBLICO_ATIVO',
  AUTONOMO_OU_PROFISSIONAL_LIBERAL = 'AUTONOMO_OU_PROFISSIONAL_LIBERAL',
  APOSENTADO_OU_PENSIONISTA_INSS = 'APOSENTADO_OU_PENSIONISTA_INSS',
  OUTROS = 'OUTROS',
  FUNCIONARIO_PUBLICO_APOSENTADO_OU_PENSIONISTA = 'FUNCIONARIO_PUBLICO_APOSENTADO_OU_PENSIONISTA',
}

export const IncomeSourceToJBCredIncomeSourceEnumMap: Record<
  Exclude<IncomeSource, IncomeSource.UNKNOWN_INCOME_SOURCE>,
  JBCredIncomeSource
> = {
  AUTONOMOUS: JBCredIncomeSource.AUTONOMO_OU_PROFISSIONAL_LIBERAL,
  CLT: JBCredIncomeSource.ASSALARIADO_CLT,
  ENTREPRENEUR: JBCredIncomeSource.AUTONOMO_OU_PROFISSIONAL_LIBERAL,
  FEDERAL_WORKER: JBCredIncomeSource.FUNCIONARIO_PUBLICO_ATIVO,
  MEI: JBCredIncomeSource.AUTONOMO_OU_PROFISSIONAL_LIBERAL,
  MILITARY: JBCredIncomeSource.FUNCIONARIO_PUBLICO_ATIVO,
  OTHER_INCOME: JBCredIncomeSource.OUTROS,
  PENSION: JBCredIncomeSource.APOSENTADO_OU_PENSIONISTA_INSS,
  RETIREMENT: JBCredIncomeSource.APOSENTADO_OU_PENSIONISTA_INSS,
  SELF_EMPLOYED: JBCredIncomeSource.AUTONOMO_OU_PROFISSIONAL_LIBERAL,
  UNEMPLOYED: JBCredIncomeSource.OUTROS,
}
